// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__8TZC4","open":"style_open__eRkuE","tooltipContent":"style_tooltipContent__lWN2Z"};